import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  fullWidthCard: {
    width: '100%',
  },
  overviewCard: {
    width: '100%',
    flex: '1 1 auto',
  },
  centeredCardActionArea: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  fitContentListItem: {
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  shrinkAvatar: {
    flexShrink: 0,
  },
  headlineListItemText: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    gap: theme.spacing(0.5),
  },
  compactListItemText: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  introButton: {
    flexShrink: 0,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  setupButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    '@container overview-card (max-width: 415px)': {
      marginBottom: 0,
      marginTop: 0,
    },
  },
}));
